import { render, staticRenderFns } from "./Topbar.vue?vue&type=template&id=412c37d6&scoped=true&"
import script from "./Topbar.vue?vue&type=script&lang=js&"
export * from "./Topbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412c37d6",
  null
  
)

export default component.exports